/*
 * File: header-cell-default.ts
 * File Created: 2023-12-19 05:10:52
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:49:35
 * Modified By: Val Liu
 * -----
 */

import { BaseTableHeaderCell } from "@root/components/table/core/lib/base-table-header-cell";
import { SortSequence } from "@root/components/table/core/lib/core";
import { Component } from "vue-property-decorator";

@Component
export default class HeaderCellDefault extends BaseTableHeaderCell {
    /// event handler
    toggleSort() {
        const currentIndex = SortSequence.indexOf(this.syncedSort);
        const nextIndex = (currentIndex + 1) % SortSequence.length;
        this.syncedSort = SortSequence[nextIndex];
    }

    /// private helpers
    get labelTitle() {
        if (this.$info.env === "development")
            return `${this.label} (${this.metaUnit.attr.name})`;
        else return this.label;
    }
}
